<template lang="pug">
  .component-credit-records
    ActionBar
      h2(slot="title") Packets
    base-list( :component="component", :dataLoader="dataLoader", :resultsPerPage="5", componentType="listing")


</template>

<script>
import KeplerBackofficeSdk from '../../../lib/kepler/backoffice'
import BaseList from '../../../pages/backoffice/BaseList'
import ActionBar from '../../structure/ui/ActionBar'
import DatePicker from '../../structure/DatePicker'
import ActionButton from '../../structure/ui/ActionButton'

export default {
  name: 'TabbedPacketRecords',
  components: {ActionButton, DatePicker, ActionBar, BaseList},
  data() {
    return {
      component: require('src/components/backoffice/PacketRecord'),

    }
  },
  created() {
  },
  methods: {
    dataLoader(callback, page = 1, resultsPerPage = 5) {
      KeplerBackofficeSdk.packetRecords.list.all(this.$route.params.id, page, resultsPerPage, (data) => {
        callback(data)
      })
    },

  },
  computed: {
    search() {
      return {
        client_id: this.$route.params.id,
        type: this.type
      }
    }
  },
  props: ['type']
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// PacketRecords.vue?0751b324